import { UserRound } from 'lucide-react';
import { Skeleton } from '@/components/ui/skeleton';
import { PillBadge } from './PillBadge';

interface PersonBadgeProps {
  roleLabel: string;
  name: string | undefined;
  isLoading: boolean;
}

export function PersonBadge({ roleLabel, name, isLoading }: PersonBadgeProps) {
  if (isLoading) return <Skeleton className="h-6.5 w-56 rounded-full" />;
  if (!name) return null;

  return (
    <PillBadge icon={UserRound} screenReaderLabel={`${roleLabel}:`} tone="solid">
      {name}
    </PillBadge>
  );
}
